import { NuxtRuntimeConfig } from "@nuxt/types/config/runtime";

let $config: NuxtRuntimeConfig;

export function exposeConfig(config: NuxtRuntimeConfig) {
  $config = config;
}

export { $config };
